import type { QrDesign } from '../domain/types';

export const DEFAULT_DESIGN: QrDesign = {
  content: 'https://example.com',
  errorCorrectionLevel: 'H',
  size: 300,

  moduleStyle: 'classic',
  moduleColor: '#000000',
  backgroundColor: '#ffffff',

  outerEyeStyle: 'square',
  innerEyeStyle: 'square',
  eyeColor: '#000000',
  outerBorderRadius: 0.5,
  innerBorderRadius: 0.5,
  styleEyesAsModules: false,

  centerImage: null,
  centerImageSize: 25,
  customModuleImage: null,
};

/** Upper bound on retained undo steps. */
export const HISTORY_LIMIT = 50;
